/* BOXO – brødsmuler som følger kundens vei gjennom butikken.
   Starter alltid på Hjem. Husker kolleksjoner/søk/sider kunden har vært innom
   (kun i denne fanen, via sessionStorage) og bytter ut temaets faste brødsmuler.
   Ved direkte innhopp (f.eks. fra Google) vises temaets egne brødsmuler uendret,
   og det er alltid den faste versjonen Google ser. */
(function () {
  var p = window.boxoPage || {};
  var KEY = 'boxoTrail';
  var MAKS = 4; // maks antall mellomledd mellom Hjem og nåværende side

  function les() { try { return JSON.parse(sessionStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function lagre(t) { try { sessionStorage.setItem(KEY, JSON.stringify(t)); } catch (e) {} }

  // Hvilke sider skal huskes i stien (produkter huskes ikke – de vises bare som siste ledd)
  var huskes = { collection: 1, search: 1, page: 1, blog: 1, article: 1, list_collections: 1 };

  // Tittel på nåværende side
  var tittel = p.type === 'collection' ? p.collection
             : p.type === 'product'    ? p.product
             : p.type === 'search'     ? 'Søk'
             : p.title || '';
  var sti = p.type === 'search' ? location.pathname + location.search : p.path;

  var trail = les();

  // Forsiden nullstiller stien
  if (p.type === 'index') { lagre([]); return; }

  // Har kunden vært på denne siden før (f.eks. trykket tilbake)? Kutt stien tilbake dit
  for (var i = 0; i < trail.length; i++) {
    if (trail[i].u === sti) { trail = trail.slice(0, i); break; }
  }

  // Bygg om brødsmulene hvis vi har en historikk å vise
  if (trail.length && tittel) {
    var html = '<a href="/" title="Tilbake til forside">Hjem</a>';
    trail.slice(-MAKS).forEach(function (s) {
      html += '<span class="breadcrumb__divider" aria-hidden="true">/</span><a href="' + s.u + '">' + s.t + '</a>';
    });
    html += '<span class="breadcrumb__divider" aria-hidden="true">/</span><span>' + tittel + '</span>';
    document.querySelectorAll('nav.breadcrumb').forEach(function (nav) { nav.innerHTML = html; });
  }

  // Legg nåværende side til stien for neste klikk
  if (huskes[p.type] && tittel) {
    trail.push({ t: tittel, u: sti });
    lagre(trail);
  }

    // Klikk i hoved-/mobil-/bunnmenyen eller på logoen = ny reise: nullstill stien
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    if (a.closest('.site-nav, .site-header, .mobile-nav, .megamenu, .site-footer')) {
      lagre([]);
    }
  }, true);
})();